function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.865.147a.48.48 0 00-.69 0l-7.82 7.82-2.542-2.54a.48.48 0 00-.678.678l2.88 2.88a.48.48 0 00.678 0l8.16-8.16a.48.48 0 00.012-.678z",
  fill: "transparent"
});

function SvgIconNotChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none"
  }, props), _ref);
}

export default SvgIconNotChecked;